import type { RawEventOfKind } from '@fullstory/recording-api';
import { RecAnimationType } from '@fullstory/recording-api';
import { ImmutableTimeline, Timeline } from './timeline/timeline';

export class AnimationEventTimeline {
  private _effectId = new Timeline<number | null>();
  public get effectId(): ImmutableTimeline<number | null> {
    return this._effectId;
  }

  private _playbackRate = new Timeline<number>();
  public get playbackRate(): ImmutableTimeline<number> {
    return this._playbackRate;
  }

  private _playState = new Timeline<AnimationPlayState>();
  public get playState(): ImmutableTimeline<AnimationPlayState> {
    return this._playState;
  }

  constructor() {
    const start = Number.NEGATIVE_INFINITY;
    const end = Number.POSITIVE_INFINITY;

    this._playbackRate.add(1, start, end);
    this._playState.add('idle', start, end);
  }

  addCreatedEvent(event: RawEventOfKind<'ANIMATION_CREATED'>) {
    const [, type, effectId] = event.Args;

    if (type === RecAnimationType.Animation) {
      this._effectId.addEventWithValue(event, effectId);
    }
  }

  addMethodEvent(event: RawEventOfKind<'ANIMATION_METHOD_CALLED'>) {
    const [, [name, params]] = event.Args;

    // TODO (scottnorvell): add support for 'commitStyles', 'persist', 'reverse', and 'updatePlaybackRate'
    switch (name) {
      case 'cancel': {
        this._playState.addEventWithValue(event, 'idle');
        break;
      }
      case 'finish': {
        this._playState.addEventWithValue(event, 'finished');
        break;
      }
      case 'pause': {
        this._playState.addEventWithValue(event, 'paused');
        break;
      }
      case 'play': {
        this._playState.addEventWithValue(event, 'running');
        break;
      }
      // TODO (scottnorvell): this is not implemented on the capture side and will possibly need revisiting
      case 'updatePlaybackRate': {
        const playbackRate = params[0];
        this._playbackRate.addEventWithValue(event, playbackRate);
        break;
      }
      // Currently unsupported methods
      case 'commitStyles':
      case 'persist':
      case 'reverse': {
        break;
      }
    }
  }
}
